import React, { useEffect, useRef } from "react";
import "./skills.css";

const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

const Skills = () => {
  const rootRef = useRef(null);

  useEffect(() => {
    const reduceMotion = window.matchMedia?.(
      "(prefers-reduced-motion: reduce)"
    )?.matches;

    if (reduceMotion) return;

    const root = rootRef.current;
    if (!root) return;

    const nodes = Array.from(
      root.querySelectorAll("[data-parallax='true']")
    );

    let rafId = 0;

    const update = () => {
      rafId = 0;
      const vh = window.innerHeight || 0;

      nodes.forEach((el) => {
        const speed = Number(el.dataset.speed || 0);
        const rect = el.getBoundingClientRect();

        const progress = clamp(
          (vh - rect.top) / (vh + rect.height),
          0,
          1
        );

        const centered = (progress - 0.5) * 2;
        const rangePx = 48;

        const y = centered * rangePx * speed;
        el.style.setProperty("--parallax-y", `${y}px`);
      });
    };

    const requestUpdate = () => {
      if (!rafId) rafId = requestAnimationFrame(update);
    };

    update();
    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", requestUpdate);

    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener("scroll", requestUpdate);
      window.removeEventListener("resize", requestUpdate);
    };
  }, []);

  return (
    <section className="skills section" id="skills" ref={rootRef}>
      <h2 className="section__title">Skills</h2>
      <span className="section__subtitle">What I work with</span>

      <div className="skills__container container">
        {/* Main card */}
        <div
          className="skills__parallaxWrap skills__parallaxWrap--primary"
          style={{ "--travel": "52px" }}
        >
          
        </div>

        {/* Grid */}
        <div className="skills__grid">
          {[
            {
              title: "Languages & Frameworks",
              items: [
                "JavaScript ● TypeScript",
                "Python",
                "Java ● Spring Boot",
                "React.js",
                "Node.js ● Express.js",
                "Dart ● Flutter",
                "C# ● .NET",
              ],
              speed: -0.2,
              travel: "10px",
            },
            {
              title: "Cloud",
              items: [
                "AWS",
                "Azure",
                "Docker",
                "Kubernetes",
                "CI/CD",
                "Terraform",
              ],
              speed: -0.2,
              travel: "10px",
            },
            // {
            //   title: "Data & Systems",
            //   items: [
            //     "Data Analysis",
            //     "Data Visualization",
            //     "Network Systems",
            //     "QGIS",
            //   ],
            //   speed: -0.2,
            //   travel: "10px",
            // },
            {
              title: "Design & UX",
              items: ["Figma", "UX Research", "Adobe XD"],
              speed: -0.2,
              travel: "10px",
            },
          ].map((block) => (
            <div
              className="skills__parallaxWrap"
              style={{ "--travel": block.travel }}
              key={block.title}
            >
              <div
                className="skills__content skills__parallax"
                data-parallax="true"
                data-speed={block.speed}
              >
                <h3 className="skills__title">{block.title}</h3>

                <div className="skills__tags">
                  {block.items.map((item) => (
                    <span className="skills__tag" key={item}>
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Context note */}
        <div className="skills__parallaxWrap" style={{ "--travel": "40px" }}>
          <div
            className="skills__content skills__parallax"
            data-parallax="true"
            data-speed="0.3"
          >
            <p className="skills__note">
              <strong>Context:</strong> Production experience building backend
              systems for healthcare research and fintech integrations.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
